import { useEffect, useRef } from 'react';
import { Chart, ChartConfiguration, registerables } from 'chart.js';

Chart.register(...registerables);

/** Create/destroy a Chart.js chart whenever the config-producing deps change.
 *  Charts are rebuilt (not updated) on theme change — Chart.js caches
 *  resolved colors, so destroy+rebuild is the reliable path. */
export const useChart = (
    build: () => ChartConfiguration | null,
    deps: unknown[],
) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;
        const config = build();
        if (!config) return undefined;
        const chart = new Chart(canvas, config);
        return () => chart.destroy();
    }, deps);
    return canvasRef;
};

/** Read a CSS custom property from the report root (theme-aware). */
export const cssVar = (el: HTMLElement | null, name: string): string =>
    el ? getComputedStyle(el).getPropertyValue(name).trim() : '#888';
